import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export default function StatCounter({ value, suffix = "", duration = 1.6, label }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.floor(value * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
      else setDisplay(value);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 16 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5 }}
      data-testid={`stat-${label?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="flex flex-col gap-2"
    >
      <div className="font-heading text-4xl md:text-5xl font-semibold text-sipl-primary tabular-nums">
        {display.toLocaleString()}
        <span className="text-sipl-accent">{suffix}</span>
      </div>
      <div className="text-sm uppercase tracking-[0.2em] text-sipl-muted">{label}</div>
    </motion.div>
  );
}
